import React, { useEffect, useState, useRef } from "react";

const TestimonialList = [
  {
    name: "Emma",
    content:
      "From Emma in the office to Jake and his staff….they provided a 1st class service. Highly recommend.",
  },
  {
    name: "Mornez",
    content:
      "“Excellent service from the initial communication to the end of the job. It was not an easy job hence I battled to find anyone willing to take it on. Many other companies are full of promises and no delivery. This company is not like them. Price was very reasonable as well.”",
  },
  {
    name: "Andrew",
    content:
      "“Top work from a good team. I’ve had gorillas for tradies in the past (those who get the job done but wreck your house in the process- so I’m a tad paranoid). These lads did everything I asked plus and were a delight to deal with - highly recommended.”",
  },
  {
    name: "Amelia",
    content:
      "“Very easy to deal with and the installers were very friendly and did a great job installing. Thanks for making it easy during lockdown to get this booked in at short notice once out of level 3 ;O)”",
  },
  {
    name: "Jagged",
    content:
      "“Jake and the team where amazing, the came out gave me a quote, and where not pushy at all, they walked me through everything and was done within 2 days very happy and now have a warm and comfortable home :)”",
  },
  {
    name: "Tom",
    content:
      "“We came to Air Mc Ltd with an unusual problem in our shucking department room. They were quick to reply and come visit our place. The job was done very quickly and smoothly. No hassles no problems. Would thoroughly recommend them.”",
  },
  {
    name: "Mike",
    content: "“Very pleasant, efficient, tidy team, great job.”",
  },
];

function Testimonials({ data }) {
  let list = undefined;

  if (data) {
    list = data;
  } else {
    list = TestimonialList;
  }

  const [selectedTest, setTest] = useState(list[0]);
  const progressRef = useRef(null);

  useEffect(() => {
    let i = 1;
    if (!!progressRef?.current) {
      progressRef.current.classList.add("active-loop");
    }
    setInterval(function () {
      if (!!progressRef?.current) {
        progressRef.current.classList.remove("active-loop");

        progressRef.current.classList.add("active-loop");
      }

      setTest(list[i]);

      if (i < list.length - 1) {
        i++;
      } else {
        i = 0;
      }
    }, 10000);
  }, [list]);

  return (
    <div className="text-center mb-20 mx-auto w-full max-w-2xl min-h-250 relative">
      <h3 className="text-black text-5xl mt-20 mb-7">Testimonials</h3>
      <p className="mb-2 md:text-xl mx-5 md:mx-20 lg:mx-auto">
        {selectedTest.content}
      </p>
      <p>{selectedTest.name}</p>
      <div
        ref={progressRef}
        className="-mb-6 progress-bar absolute bottom-0 left-0 border-b-4 w-0 border-black"
      ></div>
    </div>
  );
}

export default Testimonials;
